"use client";

import { Button } from "@/components/ui/button";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("global-error", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily: "system-ui, sans-serif",
          background:
            "radial-gradient(ellipse 70% 50% at 25% 55%, rgba(140,120,210,0.1) 0%, transparent 65%), radial-gradient(ellipse 60% 45% at 75% 45%, rgba(210,120,160,0.09) 0%, transparent 65%)",
          minHeight: "100dvh",
          display: "flex",
          flexDirection: "column",
          color: "#1a1410",
        }}>
        <div style={{ padding: "30px 40px", display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 24,
              height: 24,
              borderRadius: 6,
              background: "linear-gradient(135deg,#7c5cf6,#e05a8a)",
            }}
          />
          <span style={{ fontSize: 18, fontWeight: 600, letterSpacing: "-0.03em" }}>Zetld</span>
        </div>

        <div style={{ flex: 1, display: "grid", placeItems: "center", padding: "0 40px 60px" }}>
          <div style={{ textAlign: "center", maxWidth: 480 }}>
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 13,
                background: "linear-gradient(135deg,#7c5cf6,#e05a8a)",
                display: "grid",
                placeItems: "center",
                color: "#fff",
                fontSize: 22,
                fontWeight: 700,
                margin: "0 auto 6px",
              }}>
              P
            </div>
            <h1
              style={{ fontFamily: "Georgia,serif", fontSize: 34, marginTop: 18, lineHeight: 1.1 }}>
              Something went wrong on our end
            </h1>
            <p style={{ fontSize: 15.5, color: "#6b5f55", marginTop: 14, lineHeight: 1.55 }}>
              Prism hit an unexpected error. We&apos;ve been notified and are looking into it — your
              data is safe. Please try again shortly.
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 28 }}>
              <Button
                onClick={reset}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  height: 42,
                  padding: "0 18px",
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#7c5cf6,#e05a8a)",
                  color: "#fff",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                }}>
                Try again
              </Button>
              <Button
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  height: 42,
                  padding: "0 18px",
                  borderRadius: 10,
                  border: "1px solid #e0d8d0",
                  background: "transparent",
                  color: "#6b5f55",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                }}>
                Status page
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
